import React, { useState } from "react";
import PropTypes from "prop-types";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useApi } from "../../../../../context/api.js";
import MDButton from "../../../../../components/MDButton";
import MDTypography from "../../../../../components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";
import { setMilestone, useHomework } from "../../../../../context/homework";

function ParentValidation({ m, title, onCancel }) {
  const api = useApi();
  const [_, dispatch] = useHomework();
  const [loading, setLoading] = useState(false);

  const handleSubmission = () => {
    setLoading(true);
    api
      .submitManualValidation(m.id)
      .then((res) => {
        setLoading(false);
        if (res) {
          setMilestone(dispatch, m.id);
          onCancel();
        } else {
          // TODO : Show error ?
        }
      })
      .catch((err) => {
        setLoading(false);
        // TODO : Show error ?
      });
  };

  return (
    <>
      <DialogContent>
        {title}
        <MDTypography variant="body" component="div" mt={2}>
          Tu peux maintenant notifier ton parent que tu as terminé cette étape.
          <br />
          Il pourra alors vérifier ton travail et valider ton étape !
        </MDTypography>
      </DialogContent>
      <DialogActions>
        <MDButton disabled={!m || loading} onClick={onCancel}>
          Annuler
        </MDButton>
        <MDButton
          variant="contained"
          color="info"
          disabled={!m || loading}
          onClick={handleSubmission}
        >
          {loading && <CircularProgress size={24} />}
          {!loading && "Envoyer une notification"}
        </MDButton>
      </DialogActions>
    </>
  );
}

ParentValidation.propTypes = {
  m: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.element,
};

export default ParentValidation;
